import {createBrowserHistory} from 'history';

const history = createBrowserHistory();

export const getHistory = () => history;
export { history };
export default history;